export function getDatatableConfig() {
    return {
        'dom': 'Bfrtip',
        'autoWidth': false,
        'oLanguage': {
            'sSearch': '',
            'sEmptyTable': 'No results found',
            'sInfoEmpty': 'No results found',
            'oPaginate': {
                'sFirst': '«',
                'sPrevious': '‹',
                'sNext': '›',
                'sLast': '»'
            }
        },
        'scrollY': '50vh',
        'scrollCollapse': true,
        'paging': false,
        'bFilter': true,
        'bDestroy': true,
        'bUseRendered': false,
        'order': [[ 0, 'desc' ]],
        'rowCallback': function( row, data ) {
        },
        'enableRowDetails': false,
        // Must be a class applied to a span in the renderer
        'detailsControlClass': 'details-control',
        'childClassToListen': 'a.restore-points'
    };
}



// WEBPACK FOOTER //
// ./src/common/vca-grid/vca-grid.dt.config.ts